import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

const images = [
  { url: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80', span: 'col-span-2 row-span-2', alt: 'Khan Complex exterior view' },
  { url: 'https://images.unsplash.com/photo-1772164585108-f391c1b1771a?auto=format&fit=crop&w=600&q=80', span: 'col-span-1 row-span-1', alt: 'Modern office space interior' },
  { url: 'https://images.unsplash.com/photo-1759323321196-2813db509285?auto=format&fit=crop&w=600&q=80', span: 'col-span-1 row-span-1', alt: 'Retail shop floor' },
  { url: 'https://images.unsplash.com/photo-1771678039697-be711cc352e0?auto=format&fit=crop&w=600&q=80', span: 'col-span-1 row-span-2', alt: 'Grand commercial hall' },
  { url: 'https://images.unsplash.com/photo-1762846993248-7d8f6b8d3582?auto=format&fit=crop&w=600&q=80', span: 'col-span-1 row-span-1', alt: 'Complex walkway and balconies' },
  { url: 'https://images.unsplash.com/photo-1766790461203-1b105f775c70?auto=format&fit=crop&w=600&q=80', span: 'col-span-1 row-span-1', alt: 'Parking facility entrance' },
];

export default function GallerySection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });
  const { t } = useLanguage();

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0F172A]">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6 }} className="text-center mb-16">
          <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-bold mb-4 font-['Outfit']">{t('gallery.label')}</p>
          <h2 className="text-3xl sm:text-4xl font-light text-[#F8FAFC] font-['Cormorant_Garamond'] tracking-tight">{t('gallery.title')}</h2>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] gap-3">
          {images.map((img, i) => (
            <motion.div key={i} initial={{ opacity: 0, scale: 0.95 }} animate={inView ? { opacity: 1, scale: 1 } : {}} transition={{ duration: 0.5, delay: i * 0.1 }} data-testid={`gallery-image-${i}`} className={`${img.span} relative overflow-hidden rounded-lg group cursor-pointer`}>
              <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
